import React, { Suspense } from 'react';

import Header from '../../components/header/Header';
import Spinner from '../../components/shared/spinner/Spinner';
import { useKioskManager } from '../../hooks/useKioskManager';
import { useNetworkManager } from '../../hooks/useNetworkManager';
import styles from './styles.module.scss';

type CampusLayoutProps = {
  children: React.ReactNode;
  fullScreen?: boolean;
};

const CampusLayout: React.FC<CampusLayoutProps> = ({
  children,
  fullScreen = false,
}) => {
  const { brandingData } = useNetworkManager();
  const { kiosk, kioskMode } = useKioskManager();

  return (
    <Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Spinner iconSize={75} />
        </div>
      }
    >
      {brandingData && (
        <div className={styles.layout}>
          <Header />
          <main
            className={`${styles.main} ${
              fullScreen && styles.fullScreenOverride
            }
        ${kiosk && kioskMode && styles[kiosk.model]}
              `}
          >
            {children}
          </main>
        </div>
      )}
    </Suspense>
  );
};

export default CampusLayout;
